module.exports = __webpack_public_path__ + "static/img/38773v.e9c888d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/Images/38773v.jpg
// module id = N3ZZ
// module chunks = 1